import { render, staticRenderFns } from "./subprogram-nba-summary-teams.vue?vue&type=template&id=7833777c&scoped=true&"
import script from "./subprogram-nba-summary-teams.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-summary-teams.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-summary-teams.vue?vue&type=style&index=0&id=7833777c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833777c",
  null
  
)

export default component.exports